import { ContratoStatus, VersaoContratoEnum } from 'models/contratos';
import { Action, ContratosEntePrivadoReducerState } from './__types';
import { CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION, CLEAR_COD_COOP_ENTE_PRIVADO_ACTION, CLEAR_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION, CLEARED_CONTRATO_ENTE_PRIVADO_ACTION, CLOSE_MODAL_ENTE_PRIVADO_ADITIVO_ACTION, CLOSE_MODAL_ENTE_PRIVADO_DISTRATO_ACTION, LIST_ADENDOS_ENTE_PRIVADO_ACTION, LOADED_ADENDO_ENTE_PRIVADO_ACTION, LOADED_CONTRATO_ENTE_PRIVADO_ACTION, LOADED_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION, OPEN_MODAL_ENTE_PRIVADO_ADITIVO_ACTION, OPEN_MODAL_ENTE_PRIVADO_DISTRATO_ACTION, SET_CONTRATO_ID_ENTE_PRIVADO_ACTION } from './EntePrivadoActions';

const ADENDO_EDITING_INITIAL_STATE = {
  id: null,
  flgStatus: 0,
  versaoContrato: 1,
  codigo: '',
  ativo: false,
  idDocAssinado: null,
  idDocNaoAssinado: null,
  idDocExtrato: null,
  idDocPlanoTrabalho: null,
  extensaoDocAssinado: null,
  extensaoDocNaoAssinado: null,
  extensaoDocExtrato: null,
  extensaoDocPlanoTrabalho: null,
  dataAlteracao: '',
  incluiPlanoTrabalho: false,
  dataDistrato: ''
};

const ADENDO = {
  adendos: [ADENDO_EDITING_INITIAL_STATE],
  flgStatus: 0,
  geraAditivo: false,
  geraDistrato: false,
  idContrato: null,
  incluiPlanoTrabalho: false
};

const CONTRATO_EDITING_INITIAL_STATE = {
  codCoop: '',
  dataFim: '',
  dataInicio: '',
  emailCoop: '',
  flgAnaliseJuridica: false,
  idEstado: 0,
  nomCidade: '',
  totalMeses: '',
  programasEducacionais: [],
  flgStatus: ContratoStatus.EM_EDICAO,
  idContrato: null,
  flgAtivo: true,
  versaoContrato: VersaoContratoEnum.CONTRATO,
  nomEscola: '',
  idEscola: 0,
  cpfProfessor: '',
  tipoContrato: 0,
  dataDistrato: ''
};

const INITIAL_STATE: ContratosEntePrivadoReducerState = {
  contratoEditing: CONTRATO_EDITING_INITIAL_STATE,
  adendoEditing: ADENDO_EDITING_INITIAL_STATE,
  adendoObject: ADENDO,
  adendosAll: [],
  statusDefinitivo: 0,
  isModalAditivoOpen: false,
  isModalDistratoOpen: false,
};

export default function NewContratosEntePrivadoReducer(
  state: ContratosEntePrivadoReducerState = INITIAL_STATE,
  action: Action
): ContratosEntePrivadoReducerState {
  switch (action.type) {
    case CLEAR_COD_COOP_ENTE_PRIVADO_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          codCoop: '',
        },
      };
    case CLEARED_CONTRATO_ENTE_PRIVADO_ACTION:
      return {
        ...state,
        contratoEditing: CONTRATO_EDITING_INITIAL_STATE,
      };
    case CHANGED_CONTRATO_ENTE_PRIVADO_EDITING_VALUE_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case SET_CONTRATO_ID_ENTE_PRIVADO_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          idContrato: action.payload,
        },
      };
    case LOADED_CONTRATO_ENTE_PRIVADO_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...CONTRATO_EDITING_INITIAL_STATE,
          ...action.payload,
          idEstado: action.payload.idEstado,
          nomCidade: action.payload.nomCidade,
          nomEscola: action.payload.nomEscola,
          idEscola: action.payload.idEscola,
          cpfProfessor: action.payload.cpfProfessor,
        },
      };
    case LOADED_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION:
      return {
        ...state,
        statusDefinitivo: action.payload,
      };
    case CLEAR_CONTRATO_ENTE_PRIVADO_STATUS_GLOBAL_ACTION:
      return {
        ...state,
        statusDefinitivo: INITIAL_STATE.statusDefinitivo,
      };
    case LOADED_ADENDO_ENTE_PRIVADO_ACTION:
      return {
        ...state,
        adendoEditing: {
          ...ADENDO_EDITING_INITIAL_STATE,
          ...action.payload,
        },
        adendoObject: {
          ...ADENDO,
          ...action.payload,
        },
      };
    case LIST_ADENDOS_ENTE_PRIVADO_ACTION:
      return {
        ...state,
        adendosAll: action.payload.adendos || [],
      };
    case OPEN_MODAL_ENTE_PRIVADO_ADITIVO_ACTION:
      return { ...state, isModalAditivoOpen: true };
    case OPEN_MODAL_ENTE_PRIVADO_DISTRATO_ACTION:
      return { ...state, isModalDistratoOpen: true };
    case CLOSE_MODAL_ENTE_PRIVADO_ADITIVO_ACTION:
      return { ...state, isModalAditivoOpen: false };
    case CLOSE_MODAL_ENTE_PRIVADO_DISTRATO_ACTION:
        return { ...state, isModalDistratoOpen: false };
    default:
      return state;
  }
}
